import { SVGFC } from '@repo/toolkit/types'

const EditFormIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.4313 14.7688L10.05 15.0438C9.96875 15.0625 9.88125 15.0688 9.80625 15.0688C9.43125 15.0688 9.075 14.9063 8.8375 14.6125C8.6 14.325 8.50625 13.9438 8.58125 13.575L8.85625 12.1938C8.9375 11.7688 9.14375 11.3875 9.45625 11.075L13.1625 7.36875C13.2938 7.2375 13.4375 7.125 13.5938 7.03125V6.125C13.5938 5.175 12.8625 4.40625 11.9625 4.40625H6.1625C5.2625 4.40625 4.53125 5.175 4.53125 6.125V14.875C4.53125 15.825 5.2625 16.5938 6.1625 16.5938H11.9625C12.8625 16.5938 13.5938 15.825 13.5938 14.875V13.125L12.5438 14.175C12.2375 14.4813 11.8563 14.6875 11.4313 14.7688ZM6.875 6.90625H11.25C11.5088 6.90625 11.7188 7.11625 11.7188 7.375C11.7188 7.63375 11.5088 7.84375 11.25 7.84375H6.875C6.61625 7.84375 6.40625 7.63375 6.40625 7.375C6.40625 7.11625 6.61625 6.90625 6.875 6.90625ZM6.40625 9.25C6.40625 8.99125 6.61625 8.78125 6.875 8.78125H10C10.2588 8.78125 10.4688 8.99125 10.4688 9.25C10.4688 9.50875 10.2588 9.71875 10 9.71875H6.875C6.61625 9.71875 6.40625 9.50875 6.40625 9.25ZM15.5938 9.79938L11.8838 13.5094C11.7094 13.6838 11.4869 13.8025 11.245 13.8513L9.86625 14.1269C9.6475 14.1706 9.455 13.9775 9.49875 13.7594L9.77438 12.3806C9.8225 12.1388 9.94188 11.9163 10.1163 11.7419L13.8263 8.03188C14.3144 7.54375 15.1056 7.54375 15.5938 8.03188C16.0819 8.52 16.0819 9.31125 15.5938 9.79938Z"
        fill={color}
      />
    </svg>
  )
}

export default EditFormIcon
